import defaultLayoutComponent from '~pages/nrw/layouts/NrwDefaultLayoutComponents.js'

// const beforeEnterSearch = (to, from, next) => {
//   console.log('search root beforeEnter', to, from)
//   next()
// }

const routeInfo = [
  {
    path: 'search/course/result',
    name: 'SearchCourseResult',
    components: {
      ...defaultLayoutComponent,
      content: () => import(/* webpackChunkName: "page_searchResultMain" */ '~pages/nrw/search/SearchResultMain.vue')
    },
    beforeEnter: (to, from, next) => {
      if (Object.keys(to.query).length > 0) {
        next()
      } else {
        next('/')
      }
    },
    meta: {
      authorized: false
    },
    props: true
  }
]

export default routeInfo



// WEBPACK FOOTER //
// ./src/config/router/nrw/child/searchRouter.js